import React from 'react';
import { styled } from '@linaria/react';
import { animated } from 'react-spring';

import useBoop from '@/hooks/use-boop';

import VisuallyHidden from '@/components/VisuallyHidden';

function EmojiDemo() {
  const [style, trigger] = useBoop({
    scale: 1.25,
    springConfig: { tension: 180, friction: 15 },
  });
  const [isHovering, setIsHovering] = React.useState(false);

  return (
    <Wrapper>
      <button
        onClick={() => {
          trigger();
          setIsHovering(true);
        }}
        onMouseEnter={() => {
          trigger();
          setIsHovering(true);
        }}
        onMouseLeave={() => setIsHovering(false)}
      >
        <IconWrapper style={style}>
          {isHovering ? '😝' : '😛'}
        </IconWrapper>
        <VisuallyHidden>
          Emoji (smiling with tongue sticking out)
        </VisuallyHidden>
      </button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const IconWrapper = styled(animated.span)`
  display: block;
  font-size: 48px;
  backface-visibility: hidden;
  will-change: transform;

  i,
  svg {
    display: block !important;
  }
`;

export default EmojiDemo;
